<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="../assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
            <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">شما مجوز ورود به این سیستم را ندارید!</h1>
            <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse">
              کاربر شما برای استفاده از سیستم تعریف نشده است. درصورتی که تمایل دارید میتوانید با مدیر سیستم تماس حاصل نمایید.
            </p>
            <vs-button size="large" @click="logout()">خروج از سیستم</vs-button>
        </div>
    </div>
</template>

<script>
export default {
    created() {
      window.setTimeout(() => {
        this.logout();
      }, 4000)
    },
    methods: {
      logout() {
        this.$auth.logOut();
        //this.$auth.signinRedirect();
      }
    }
};
</script>

<style lang="scss">
@import "../assets/css/loader.css";
</style>
